import { Clock, LogOut, Repeat } from "lucide-react";

// أنواع الإجازة الزمنية الثلاثة (البند 1) — لون وأيقونة لكل نوع بأسلوب الرئيسية.
export const TIME_OFF_TYPES = [
  { key: "start_delay", icon: Clock,  color: "bg-amber-500" },
  { key: "early_leave", icon: LogOut, color: "bg-rose-500" },
  { key: "mid_day",     icon: Repeat, color: "bg-violet-600" },
];

// أوقات مطلوبة لكل نوع (البند 1).
export const NEEDS_START = ["early_leave", "mid_day"];
export const NEEDS_END = ["start_delay", "mid_day"];
